import React from "react";

function SelfEvaluationForm({ userName }) {
    return (
        <div className="document">
            <h1 className="evaluation-title">How to Take the Pre-Test and Post-Test</h1>

                <ol>
                <li>Go to <a href="https://fpms.hacktonia.com/self-evaluation" target="_blank" rel="noopener noreferrer">https://fpms.hacktonia.com/self-evaluation</a></li>
                <li>If you are not signed in, sign in to NYX NoCode with your team login</li>
                <li>Choose Pre-Test for before the NYX NoCode Demo or Post-Test for after the NYX NoCode Demo</li>
                <li>Complete the test and click the Submit Self-Evaluation button</li>
                <li>Repeat for each team member</li>
                <li>When finished, either return to <a href="https://fpms.hacktonia.com" target="_blank" rel="noopener noreferrer">https://fpms.hacktonia.com</a> or Sign Out.</li>
            </ol>

            <div className="bonus-section">
                <h2>BONUS: DID YOU KNOW?</h2>
                <p>Your answers are automatically saved in the SELF_EVALUATIONS folder in your NYX NoCode Gallery so the teachers can see them later. The answers are
                    saved in a format called JSON, which stands for JavaScript Object Notation.</p>
                <p>The JSON is saved on a BLOB, or Basic Large OBject storage in the Azure Cloud, which is the same place that all of your
                    other creations are stored. The JSON for your self-evaluation looks something like this:</p>

                <pre className="json-code">
    {JSON.stringify({
        "aiFamiliarity": "5",
        "aiForGood": "that we can use AI to do good things, not destructive",
        "aiScienceUse": "it can dive very deeply into data",
        "websiteConfidence": "4",
        "codeVsNoCode": "coding you have to write the code, Nocode you draw or prompt",
        "userName": "kilroy@uark.edu",
        "evaluationType": "pre-test",
        "submittedAt": "2025-03-03T13:31:22.279Z"
    }, null, 2)}
</pre>

            </div>
        </div>
    );
}

export default SelfEvaluationForm;
